import { render, staticRenderFns } from "./disableResultModal.vue?vue&type=template&id=68e05a08&scoped=true"
import script from "./disableResultModal.vue?vue&type=script&lang=js"
export * from "./disableResultModal.vue?vue&type=script&lang=js"
import style0 from "./disableResultModal.vue?vue&type=style&index=0&id=68e05a08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e05a08",
  null
  
)

export default component.exports